export function canSeeSignatureRequests(
  pages: readonly string[] | undefined
): boolean {
  return (
    pages?.includes("leads") === true || pages?.includes("projects") === true
  )
}
